import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ConversationDataService } from '../../core/services/conversation-data.service';
import {
  APPOINTMENT_DETAILS_API_ACTIONS,
  CAMPAIGN_DETAILS_API_ACTIONS,
  CONTACT_DETAILS_API_ACTIONS,
  CONVERSATION_DETAILS_API_ACTIONS,
  LEASING_PREFERENCES_API_ACTIONS,
  TAGS_API_ACTIONS,
} from '../actions';
import { APPLICATION_REDUCER } from '../reducers/application.reducer';
import { Store } from '@ngrx/store';

@Injectable()
export class ConversationDataEffects {
  constructor(
    private readonly conversationDetailsService: ConversationDataService,
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  getTags$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TAGS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.conversationDetailsService.getTags(queryName, value)),
      map((data) => TAGS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(TAGS_API_ACTIONS.error({ error }))),
    );
  });

  getConversationDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONVERSATION_DETAILS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.conversationDetailsService.getConversationDetails(queryName, value)),
      map((data) => CONVERSATION_DETAILS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(CONVERSATION_DETAILS_API_ACTIONS.error({ error }))),
    );
  });

  getContactDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONTACT_DETAILS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.conversationDetailsService.getContactDetails(queryName, value)),
      map((data) => CONTACT_DETAILS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(CONTACT_DETAILS_API_ACTIONS.error({ error }))),
    );
  });

  getLeasingPreferences$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LEASING_PREFERENCES_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.conversationDetailsService.getLeasingPreferences(queryName, value)),
      map((data) => LEASING_PREFERENCES_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(LEASING_PREFERENCES_API_ACTIONS.error({ error }))),
    );
  });

  getAppointmentDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(APPOINTMENT_DETAILS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.conversationDetailsService.getAppointmentDetails(queryName, value)),
      map((data) => APPOINTMENT_DETAILS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(APPOINTMENT_DETAILS_API_ACTIONS.error({ error }))),
    );
  });

  getCampaignDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CAMPAIGN_DETAILS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.conversationDetailsService.getCampaignDetails(queryName, value)),
      map((data) => CAMPAIGN_DETAILS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(CAMPAIGN_DETAILS_API_ACTIONS.error({ error }))),
    );
  });
}
